import { Link } from 'gatsby'
import { Image } from 'src/components/ui/Image'
import type { SocialData } from 'src/components/global/types'

import type { TrackFooterCTAParams } from './validateFooter'

type SocialMediaProps = {
  socialLinks: SocialData[]
  onTrackCTA: (params: TrackFooterCTAParams) => void
}

export const SocialMedia = ({ socialLinks, onTrackCTA }: SocialMediaProps) => {
  return (
    <div className="flex flex-row gap-4 min-w-[32px] max-w-[210px] flex-wrap">
      {socialLinks.map((socialLink) => {
        const { image, link, text } = socialLink

        if (socialLink.link.includes('https')) {
          return (
            <a
              key={link}
              target="_blank"
              href={socialLink.link}
              data-testid={`footerSocialMedia${text}`}
              onClick={() =>
                onTrackCTA({ ctaCategory: 'Redes sociais', ctaName: text })
              }
              className="flex flex-col border-[1px] rounded-[360px] border-restructure-border-primary placeholder:min-h-[32px] min-w-[32px] min-h-[32px] max-w-[32px] justify-center items-center hover:bg-white/15"
              rel="noopener noreferrer"
            >
              <div className="w-4 h-4">
                <Image
                  src={image}
                  alt={text}
                  width={16}
                  height={16}
                  className="w-full max-w-full"
                />
              </div>
            </a>
          )
        }

        return (
          <Link
            key={link}
            target="_blank"
            to={socialLink.link}
            data-testid={`footerSocialMedia${text}`}
            onClick={() =>
              onTrackCTA({ ctaCategory: 'Redes sociais', ctaName: text })
            }
            className="flex flex-col border-[1px] rounded-[360px] border-restructure-border-primary placeholder:min-h-[32px] min-w-[32px] min-h-[32px] max-w-[32px] justify-center items-center"
            rel="noopener noreferrer"
          >
            <div className="w-4 h-4">
              <Image
                src={image}
                alt={text}
                width={16}
                height={16}
                className="w-full max-w-full"
              />
            </div>
          </Link>
        )
      })}
    </div>
  )
}
